import * as Preact from "preact"
import "@fae/source/views/components/Cursor.less"
import App from "@fae/source/models/App.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Dev from "@fae/source/models/dev/Dev.js"
import World from "@fae/source/models/World.js"

import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@fae/source/views/components/UnitTemplateSprite.jsx"
import TileTemplateThumbnail from "@fae/source/views/components/TileTemplateThumbnail.jsx"

export default class Cursor {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.dialogue != undefined) return
        // if(App.game.chapter.selection.position.z == 0) {
        //     return
        // }
        if(App.options.disableActionUI == true) return
        if(World.isOutOfBounds(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.inProtoMode == false
        && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], App.game.chapter.selection.position) == false) {
            return
        }

        if(Dev.inProtoMode == false
        && World.isEmptyPosition(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.selectedTemplate != undefined) {
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <UnitTemplateSprite unitTemplate={Dev.selectedTemplate}/>
                </div>
            )
        }
        if(Dev.devSelection.selectedSpotTemplate != undefined) {
            let style = ""
            if(Dev.tagColors[Dev.devSelection.selectedSpotTemplate.tag] != undefined) {
                style = "background-color:" + Dev.tagColors[Dev.devSelection.selectedSpotTemplate.tag]
            }
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <div class="Spot" style={style}/>
                </div>
            )
        }
        // dialogs, resize, new_window, fullscreen, square, screenshot_region, activity_zone
        if(Dev.devSelection.selectedEncounterAsset != undefined) {
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <span class="CursorIcon material-symbols-rounded">
                        {Dev.devSelection.selectedEncounterAsset == "rectangle" ? "activity_zone" : "graph_6"}
                    </span>
                </div>
            )
        }
        if(Dev.devSelection.selectedTileTemplate) {
            return (
                <div class="Cursor" style={this.style}>
                    <TileTemplateThumbnail template={Dev.devSelection.selectedTileTemplate}/>
                    <div class="Sprite" isHovered={this.isHovered}/>
                </div>
            )
        }

        return (
            <div class="Cursor" style={this.style}>
                <div class="Sprite" isHovered={this.isHovered}/>
            </div>
        )
    }
    get isHovered() {
        return App.game.chapter.selection.hoveredUnitKey != undefined
    }
    get style() {
        const selection = App.game.chapter.selection

        return {
            "left": selection.position.x + "em",
            "top": selection.position.y + "em",
        }
    }
}
